import * as actionTypes from "./actionTypes";
import apiClient from "../../services/apiClient";
import { getMerchantId } from "../../utils/tokenManager";
import { showErrorToast } from "../../utils/errorHandler";
import { deleteItemStart } from "./addItem";

export const getInventoryStart = () => {
  return {
    type: actionTypes.GET_INVENTORY_START,
  };
};

export const getInventorySuccess = (data) => {
  return {
    type: actionTypes.GET_INVENTORY_SUCCESS,
    data,
  };
};

export const getInventoryFail = () => {
  return {
    type: actionTypes.GET_INVENTORY_FAIL,
  };
};

export const updatePerPageSelectStart = (name, value) => {
  return {
    type: actionTypes.UPDATE_SELECT_PER_PAGE_INVENTORY,
    value,
    name,
  };
};

export const updatePerPageSelectInventory = (name, value) => {
  return (dispatch) => {
    dispatch(updatePerPageSelectStart(name, value));
  };
};

export const updatePageSelectStart = (value) => {
  return {
    type: actionTypes.UPDATE_SELECT_PAGE_INVENTORY,
    value,
  };
};

export const updatePageSelectInventory = (value) => {
  return (dispatch) => {
    dispatch(updatePageSelectStart(value));
  };
};

export const getInventory = (
  limit,
  page,
  sortBy,
  sortOrder,
  searchInput,
  categoryId
) => {
  return async (dispatch) => {
    dispatch(getInventoryStart());
    dispatch(deleteItemStart()); // Close modal

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(getInventoryFail());
        return;
      }

      // Build query parameters aligned with backend
      const params = new URLSearchParams();
      
      params.append('limit', limit);
      params.append('page', page);
      
      if (searchInput) {
        params.append('search', searchInput);
      }
      
      if (sortBy) {
        params.append('sortBy', sortBy);
        params.append('sortOrder', sortOrder);
      }
      
      if (categoryId && categoryId !== 0) {
        params.append('categoryId', categoryId);
      }

      const response = await apiClient.get(
        `/products/merchants/${merchantId}/products?${params.toString()}`
      );
      
      // Backend wraps response in {success, data, message, pagination}
      const productsData = response.data.data;
      const pagination = response.data.pagination;
      
      dispatch(getInventorySuccess({ items: productsData, pagination }));
    } catch (error) {
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to fetch inventory';
      showErrorToast({ message: errorMessage });
      dispatch(getInventoryFail());
    }
  };
};
